import React, { useEffect } from 'react';
import {useLocation,useNavigate } from 'react-router-dom';
import {MdOutlineSpaceDashboard} from 'react-icons/md';
import { useSelector } from 'react-redux';
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineLeaderboard } from "react-icons/md";
import { RiChatFollowUpLine } from "react-icons/ri";
import { TbMoneybag } from "react-icons/tb";
import { TbTransferIn } from "react-icons/tb";
import { PiPhoneCall } from "react-icons/pi";
import { PiTargetBold } from "react-icons/pi";
import { IoChatbubbleOutline } from "react-icons/io5";
import { MdTrackChanges } from "react-icons/md";
import { TbPhoneCall } from "react-icons/tb";
import { TbMessage2Plus } from "react-icons/tb";
import { SiGoogleclassroom } from "react-icons/si";

function DashboardMenu() {

  const {pathname} = useLocation();
  const path = pathname.split('/')[2]
  const user = useSelector(state=>state.Auth)
  const roles = useSelector(state=>state.Auth.roles)

  const navigate = useNavigate();

  useEffect(()=>{
    if(path === undefined){
      navigate('/dashboard/my_dashboard')
    }
  },[])


  const menu = [
    {name:'My Dashboard',icon:MdOutlineSpaceDashboard,path:'/dashboard/my_dashboard',id:1,color:'',roles:[]},
    {name:'Chat Window',icon:IoChatbubbleOutline,path:'/dashboard/chat_window',id:1,color:'',roles:['executive_team','admin','wfh']},
    {name:'VoiceCall Followup',icon:TbPhoneCall,path:'/dashboard/voice_call_answered_assigned',id:1,color:'',roles:['executive_team','admin','wfh']},
    {name:'Message Followup',icon:TbMessage2Plus,path:'/dashboard/template_message_delivered_assigned',id:1,color:'',roles:['executive_team','admin','wfh']},
    {name:'Live Class',icon:SiGoogleclassroom,path:`/dashboard/live_class`,id:1,color:'',roles:['executive_team','admin','wfh']}
  ]  

  const menu1 = [
    {name:'Our Clients',icon:FaRegUserCircle,path:'/dashboard/our_clients',id:1,color:'',roles:[]},
    // {name:'Mass Message',icon:RiMessage3Line,path:'/dashboard/our_clients_analytics',id:1,color:'',roles:[]},
    {name:'ReTarget Customer',icon:PiTargetBold,path:'/dashboard/retarget_customer',id:1,color:'',roles:[]},
    {name:'New Clients',icon:RiChatFollowUpLine,path:'/dashboard/new_clients',id:2,color:'',roles:[]},
    {name:'Call Followup',icon:PiPhoneCall,path:'/dashboard/admin_call_followup',id:2,color:'',roles:[]},
    {name:'Leader Board',icon:MdOutlineLeaderboard,path:'/dashboard/leader_board',id:3,color:'',roles:[]},
    // {name:'Leader Board New',icon:MdOutlineLeaderboard,path:'/dashboard/leader_board_main',id:3,color:'',roles:[]},
    {name:'WithDraw Request',icon:TbMoneybag,path:`/dashboard/withdraw_request`,id:1,color:'',roles:[]},
    {name:'Transfer Client',icon:TbTransferIn,path:`/dashboard/subscribed_client_transfer`,id:1,color:'',roles:[]},
    {name:'Track Employee',icon:MdTrackChanges,path:`/dashboard/track_employee`,id:1,color:'',roles:[]},
    
  ]  

  

  

  return (
    <div className='md:mr-0 md:min-h-screen md:max-h-sceen md:border-r  md:min-w-44 md:max-w-44 md:w-44 px-2' >

        <div className='mb-4 mt-4'>
        <h6 className='mb-2 font-[700] text-[12px]'>Our Dashboard</h6>
       
        <div className='flex flex-wrap mr-2 md:block w-auto'>
            {menu
            .filter(m => m.roles.length === 0 || m.roles.some(r => roles?.includes(r)))
            .map((m)=>(
               <React.Fragment key={m?.path}>
                <div key={m?.path} className={`flex items-center w-max md:w-[100%] my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                  {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                  <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                  <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>
              </React.Fragment> 
            ))}
        </div>    
        </div>

        {roles?.includes('admin') &&
        <div className='mb-4 border-t pt-4 mt-4'>
        <h6 className='mb-2 font-[700] text-[12px]'>Admin Menu</h6>
       
        <div className='flex flex-wrap mr-2 md:block w-auto'>
            {menu1.map((m)=>(
               <React.Fragment key={m?.path}>
                <div key={m?.path} className={`flex items-center w-max md:w-[100%] my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                  {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                  <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                  <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>
              </React.Fragment> 
            ))}
        </div>    
        </div>}

       

    </div>
  )
}

export default DashboardMenu